import { Action as ReduxAction } from 'redux';

namespace PictureStorageAction {
  export enum ActionType {
    FINISH_TASKS = 'PICTURE_STORAGE_FINISH_TASKS',
  }

  export enum TaskType {
    Reading,
    Writing,
    Encoding,
    Decoding,
  }

  interface SimpleTaskResult {
    type: TaskType.Writing;
    id: string;
  }

  interface TaskResultWithBlob {
    type: TaskType.Reading | TaskType.Encoding;
    id: string;
    blob: Blob;
  }

  interface TaskResultWithImage<Image> {
    type: TaskType.Decoding;
    id: string;
    image: Image;
  }

  export type TaskResult<Image> = (
    SimpleTaskResult
    | TaskResultWithBlob
    | TaskResultWithImage<Image>
  );

  interface ActionBase extends ReduxAction {
    target: any;
  }

  interface FinishTasksAction<Image> extends ActionBase {
    type: ActionType.FINISH_TASKS;
    taskResults: ReadonlyArray<TaskResult<Image>>;
  }

  export type Action<Image> = FinishTasksAction<Image>;

  export const finishTasks = <Image>(
    target: any,
    taskResults: ReadonlyArray<TaskResult<Image>>,
  ): FinishTasksAction<Image> => ({
    target, taskResults, type: ActionType.FINISH_TASKS,
  });

  export function isDomesticAction<Image>(
    action: ReduxAction,
    target: any,
  ): action is Action<Image> {
    if (!Object.keys(ActionType).some(k => action.type === ActionType[k as any])) {
      return false;
    }

    return (action as ActionBase).target === target;
  }
}

export default PictureStorageAction;
